import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default (action$) =>
  action$.ofType(Types.SYNCHRONIZE_CUSTOMERS).mergeMap(
    (action) => {
      const { customers } = action;
      const syncCustomer = firebase.functions().httpsCallable("syncCustomer");

      return Promise.all(
        customers.map((customer) => syncCustomer({ customerId: customer.key }))
      )
        .then((results) => Creators.syncComplete(results.map((r) => r.data)))
        .catch(() => Creators.setSyncStatus(false, false));
    }

    //   new Promise((resolve, reject) => {
    //     const { customers } = action;
    //     const syncCustomer = firebase.functions().httpsCallable("syncCustomer");

    //     const syncs = customers.map((customer) =>
    //       syncCustomer({ customerId: customer.key })
    //     );

    //     Promise.all(syncs)
    //       .then((result) => {
    //         Creators.setSynchronizingStatus(false);
    //         Creators.setSyncStatus(true);
    //         return resolve();
    //       })
    //       .catch((reason) => {
    //         Creators.setSynchronizingStatus(false);
    //         return reject(reason);
    //       });
    //   })
  );



// WEBPACK FOOTER //
// ./src/staff/epics/synchronizeCustomers.js